<svg
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 548.291 548.291"
  style="enable-background: new 0 0 548.291 548.291"
  xml:space="preserve"
>
  <g>
    <path
      d="M486.201,196.121h-13.166v-63.525c0-0.399-0.062-0.795-0.115-1.2c-0.021-2.522-0.825-5-2.552-6.96L364.657,3.675
		c-0.033-0.031-0.064-0.042-0.085-0.073c-0.63-0.704-1.364-1.292-2.143-1.796c-0.229-0.157-0.461-0.286-0.702-0.419
		c-0.672-0.365-1.387-0.672-2.121-0.893c-0.2-0.052-0.379-0.134-0.577-0.188C358.23,0.118,357.401,0,356.562,0H96.757
		C84.894,0,75.256,9.649,75.256,21.502v174.613H62.092c-16.971,0-30.732,13.756-30.732,30.73v159.81
		c0,16.966,13.761,30.736,30.732,30.736h13.164V526.79c0,11.854,9.638,21.501,21.501,21.501h354.776
		c11.853,0,21.501-9.647,21.501-21.501V417.392h13.166c16.966,0,30.729-13.764,30.729-30.731v-159.81
		C516.93,209.877,503.167,196.121,486.201,196.121z M96.757,21.507h249.054v110.006c0,5.94,4.817,10.751,10.751,10.751h94.972
		v53.861H96.757V21.507z M376.924,273.865c0,14.308-4.783,26.471-13.454,34.706c-11.287,10.646-27.995,15.413-47.523,15.413
		c-4.342,0-8.248-0.221-11.281-0.642v52.279h-32.783V231.336c10.21-1.753,24.53-3.054,44.709-3.054
		c20.395,0,34.93,3.917,44.704,11.74C370.635,247.387,376.924,259.534,376.924,273.865z M85.035,375.622l9.331-146.238h44.045
		l14.326,48.819c4.565,16.919,9.113,35.15,12.37,52.289h0.662c4.12-16.924,9.11-36.22,13.884-52.499l15.625-48.609h43.182
		l8.024,146.238h-32.321l-2.173-55.969c-0.661-17.579-1.304-38.861-1.304-60.119h-0.646c-4.564,18.669-10.637,39.499-16.286,56.649
		l-17.782,57.062h-25.825l-15.625-56.651c-4.769-17.135-9.77-37.965-13.236-57.06h-0.441c-0.863,19.752-1.514,42.309-2.596,60.539
		l-2.611,55.549H85.035z M451.534,520.968H96.757V417.392h354.776V520.968z M433.794,378.01c-18.24,0-33.643-4.766-41.889-9.968
		l6.734-24.751c5.854,3.044,19.308,8.672,32.768,8.672c17.135,0,25.816-8.242,25.816-18.867c0-13.88-13.891-20.188-28.432-20.188
		h-13.459v-23.654h12.813c11.062-0.2,25.177-4.325,25.177-16.271c0-8.459-6.95-14.737-20.835-14.737
		c-11.502,0-23.653,4.986-29.512,8.459l-6.721-23.882c8.463-5.417,25.377-10.627,43.618-10.627
		c30.157,0,46.871,15.843,46.871,35.161c0,14.958-8.472,26.686-25.826,32.758v0.441c16.935,3.04,30.609,15.827,30.609,34.278
		C491.513,359.785,469.596,378.01,433.794,378.01z"
    />
    <path
      d="M318.325,253.255c-6.72,0-11.281,0.641-13.659,1.291v43.18c2.819,0.64,6.3,0.871,11.065,0.871
		c17.575,0,28.437-8.903,28.437-23.885C344.162,261.277,334.829,253.255,318.325,253.255z"
    />
  </g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
</svg>
